export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
